// PVL Season 4 (2025) fixtures and results. `home`/`away` must match keys in TEAM_LOGOS.
export const SEASON_TITLE = 'Prime Volleyball League powered by Scapia Season 4';

export const fixtures = [
  // Day 1 - Thu Oct 2, 2025
  {
    matchNo: 1,
    stage: 'League',
    date: 'Thu Oct 2, 2025 | 6:30 PM IST',
    home: 'Hyderabad Black Hawks',
    away: 'Calicut Heroes',
    score: '3-0',
    sets: '15:12 18:16 18:16',
  },
  // Day 2 - Fri Oct 3, 2025
  {
    matchNo: 2,
    stage: 'League',
    date: 'Fri Oct 3, 2025 | 6:30 PM IST',
    home: 'Goa Guardians',
    away: 'Bengaluru Torpedoes',
    score: '2-3',
    sets: '9:15 15:11 15:13 15:17 9:15',
  },
  {
    matchNo: 3,
    stage: 'League',
    date: 'Fri Oct 3, 2025 | 8:30 PM IST',
    home: 'Chennai Blitz',
    away: 'Kochi Blue Spikers',
    score: '2-3',
    sets: '15:13 16:14 11:15 11:15 12:15',
  },
  // Day 3 - Sat Oct 4, 2025
  {
    matchNo: 4,
    stage: 'League',
    date: 'Sat Oct 4, 2025 | 6:30 PM IST',
    home: 'Delhi Toofans',
    away: 'Ahmedabad Defenders',
    score: '2-3',
    sets: '15:13 15:13 13:15 8:15 16:18',
  },
  {
    matchNo: 5,
    stage: 'League',
    date: 'Sat Oct 4, 2025 | 8:30 PM IST',
    home: 'Hyderabad Black Hawks',
    away: 'Mumbai Meteors',
    score: '3-0',
    sets: '15:9 15:13 15:7',
  },
  // Day 4 - Sun Oct 5, 2025
  {
    matchNo: 6,
    stage: 'League',
    date: 'Sun Oct 5, 2025 | 6:30 PM IST',
    home: 'Kolkata Thunderbolts',
    away: 'Bengaluru Torpedoes',
    score: '1-3',
    sets: '15:11 13:15 11:15 11:15',
  },
  {
    matchNo: 7,
    stage: 'League',
    date: 'Sun Oct 5, 2025 | 8:30 PM IST',
    home: 'Kochi Blue Spikers',
    away: 'Goa Guardians',
    score: '3-2',
    sets: '11:15 17:15 15:13 10:15 15:10',
  },
  // Day 5 - Mon Oct 6, 2025
  {
    matchNo: 8,
    stage: 'League',
    date: 'Mon Oct 6, 2025 | 6:30 PM IST',
    home: 'Mumbai Meteors',
    away: 'Calicut Heroes',
    score: '3-0',
    sets: '15:9 15:8 15:12',
  },
  // Day 6 - Tue Oct 7, 2025
  {
    matchNo: 9,
    stage: 'League',
    date: 'Tue Oct 7, 2025 | 6:30 PM IST',
    home: 'Kolkata Thunderbolts',
    away: 'Kochi Blue Spikers',
    score: '3-1',
    sets: '12:15 15:13 15:6 19:17',
  },
  {
    matchNo: 10,
    stage: 'League',
    date: 'Tue Oct 7, 2025 | 8:30 PM IST',
    home: 'Goa Guardians',
    away: 'Ahmedabad Defenders',
    score: '3-2',
    sets: '13:15 15:11 9:15 19:17',
  },
  // Day 7 - Wed Oct 8, 2025
  {
    matchNo: 11,
    stage: 'League',
    date: 'Wed Oct 8, 2025 | 6:30 PM IST',
    home: 'Mumbai Meteors',
    away: 'Delhi Toofans',
    score: '3-0',
    sets: '15:12 15:10 15:11',
  },
  // Day 8 - Thu Oct 9, 2025
  {
    matchNo: 12,
    stage: 'League',
    date: 'Thu Oct 9, 2025 | 6:30 PM IST',
    home: 'Goa Guardians',
    away: 'Chennai Blitz',
    score: '2-3',
    sets: '15:12 11:15 15:10 16:19 13:15',
  },
  // Day 9 - Fri Oct 10, 2025
  {
    matchNo: 13,
    stage: 'League',
    date: 'Fri Oct 10, 2025 | 6:30 PM IST',
    home: 'Calicut Heroes',
    away: 'Ahmedabad Defenders',
    score: '1-3',
    sets: '15:12 12:15 12:15 14:16',
  },
  {
    matchNo: 14,
    stage: 'League',
    date: 'Fri Oct 10, 2025 | 8:30 PM IST',
    home: 'Hyderabad Black Hawks',
    away: 'Delhi Toofans',
    score: '0-3',
    sets: '10:15 14:16 15:17',
  },
  // Day 10 - Sat Oct 11, 2025
  {
    matchNo: 15,
    stage: 'League',
    date: 'Sat Oct 11, 2025 | 6:30 PM IST',
    home: 'Kochi Blue Spikers',
    away: 'Bengaluru Torpedoes',
    score: '1-3',
    sets: '15:13 15:17 9:15 12:15',
  },
  {
    matchNo: 16,
    stage: 'League',
    date: 'Sat Oct 11, 2025 | 8:30 PM IST',
    home: 'Kolkata Thunderbolts',
    away: 'Chennai Blitz',
    score: '3-0',
    sets: '15:11 15:12 15:13',
  },
  // Day 11 - Sun Oct 12, 2025
  {
    matchNo: 17,
    stage: 'League',
    date: 'Sun Oct 12, 2025 | 6:30 PM IST',
    home: 'Delhi Toofans',
    away: 'Calicut Heroes',
    score: '3-0',
    sets: '15:11 15:9 15:11',
  },
  {
    matchNo: 18,
    stage: 'League',
    date: 'Sun Oct 12, 2025 | 8:30 PM IST',
    home: 'Ahmedabad Defenders',
    away: 'Hyderabad Black Hawks',
    score: '3-2',
    sets: '9:15 7:15 15:9 15:11 15:8',
  },
  // Day 12 - Mon Oct 13, 2025
  {
    matchNo: 19,
    stage: 'League',
    date: 'Mon Oct 13, 2025 | 6:30 PM IST',
    home: 'Bengaluru Torpedoes',
    away: 'Chennai Blitz',
    score: '3-1',
    sets: '17:15 14:16 17:15 16:14',
  },
  // Day 13 - Tue Oct 14, 2025
  {
    matchNo: 20,
    stage: 'League',
    date: 'Tue Oct 14, 2025 | 6:30 PM IST',
    home: 'Mumbai Meteors',
    away: 'Kochi Blue Spikers',
    score: '3-2',
    sets: '15:7 7:15 13:15 15:11',
  },
  {
    matchNo: 21,
    stage: 'League',
    date: 'Tue Oct 14, 2025 | 8:30 PM IST',
    home: 'Kolkata Thunderbolts',
    away: 'Goa Guardians',
    score: '0-3',
    sets: '11:15 8:15 6:15',
  },
  // Day 14 - Wed Oct 15, 2025
  {
    matchNo: 22,
    stage: 'League',
    date: 'Wed Oct 15, 2025 | 6:30 PM IST',
    home: 'Chennai Blitz',
    away: 'Ahmedabad Defenders',
    score: '3-2',
    sets: '15:10 10:15 15:11 12:15 15:13',
  },
  {
    matchNo: 23,
    stage: 'League',
    date: 'Wed Oct 15, 2025 | 8:30 PM IST',
    home: 'Bengaluru Torpedoes',
    away: 'Calicut Heroes',
    score: '3-2',
    sets: '20:18 20:18 7:15 11:15 15:12',
  },
  // Day 15 - Thu Oct 16, 2025
  {
    matchNo: 24,
    stage: 'League',
    date: 'Thu Oct 16, 2025 | 6:30 PM IST',
    home: 'Goa Guardians',
    away: 'Hyderabad Black Hawks',
    score: '1-3',
    sets: '13:15 18:20 17:15 9:15',
  },
  // Day 16 - Fri Oct 17, 2025
  {
    matchNo: 25,
    stage: 'League',
    date: 'Fri Oct 17, 2025 | 6:30 PM IST',
    home: 'Calicut Heroes',
    away: 'Kolkata Thunderbolts',
    score: '3-0',
    sets: '15:10 15:11 15:12',
  },
  {
    matchNo: 26,
    stage: 'League',
    date: 'Fri Oct 17, 2025 | 8:30 PM IST',
    home: 'Delhi Toofans',
    away: 'Chennai Blitz',
    score: '0-3',
    sets: '10:15 10:15 10:15',
  },
  // Day 17 - Sat Oct 18, 2025
  {
    matchNo: 27,
    stage: 'League',
    date: 'Sat Oct 18, 2025 | 6:30 PM IST',
    home: 'Ahmedabad Defenders',
    away: 'Mumbai Meteors',
    score: '3-1',
    sets: '12:15 15:7 15:12 21:20',
  },
  {
    matchNo: 28,
    stage: 'League',
    date: 'Sat Oct 18, 2025 | 8:30 PM IST',
    home: 'Bengaluru Torpedoes',
    away: 'Hyderabad Black Hawks',
    score: '2-3',
    sets: '15:13 10:15 16:18 16:14 11:15',
  },
  // Day 18 - Sun Oct 19, 2025
  {
    matchNo: 29,
    stage: 'League',
    date: 'Sun Oct 19, 2025 | 6:30 PM IST',
    home: 'Delhi Toofans',
    away: 'Goa Guardians',
    score: '2-3',
    sets: '16:14 15:11 11:15 13:16 11:15',
  },
  {
    matchNo: 30,
    stage: 'League',
    date: 'Sun Oct 19, 2025 | 8:30 PM IST',
    home: 'Kochi Blue Spikers',
    away: 'Calicut Heroes',
    score: '3-1',
    sets: '15:13 9:15 15:8 15:13',
  },
  // Day 19 - Mon Oct 20, 2025
  {
    matchNo: 31,
    stage: 'League',
    date: 'Mon Oct 20, 2025 | 6:30 PM IST',
    home: 'Hyderabad Black Hawks',
    away: 'Kolkata Thunderbolts',
    score: '1-3',
    sets: '9:15 13:15 15:9 13:15',
  },
  {
    matchNo: 32,
    stage: 'League',
    date: 'Mon Oct 20, 2025 | 8:30 PM IST',
    home: 'Chennai Blitz',
    away: 'Mumbai Meteors',
    score: '1-3',
    sets: '14:16 15:11 12:15 19:21',
  },
  // Day 20 - Tue Oct 21, 2025
  {
    matchNo: 33,
    stage: 'League',
    date: 'Tue Oct 21, 2025 | 6:30 PM IST',
    home: 'Ahmedabad Defenders',
    away: 'Kochi Blue Spikers',
    score: '1-3',
    sets: '13:15 16:14 15:17 9:15',
  },
  // Day 21 - Wed Oct 22, 2025
  {
    matchNo: 34,
    stage: 'League',
    date: 'Wed Oct 22, 2025 | 6:30 PM IST',
    home: 'Mumbai Meteors',
    away: 'Bengaluru Torpedoes',
    score: '3-1',
    sets: '15:13 15:13 18:20 15:10',
  },
  {
    matchNo: 35,
    stage: 'League',
    date: 'Wed Oct 22, 2025 | 8:30 PM IST',
    home: 'Kolkata Thunderbolts',
    away: 'Delhi Toofans',
    score: '2-3',
    sets: '16:18 15:11 15:12 11:15 12:15',
  },
  // Day 22 - Thu Oct 23, 2025 → Rest Day (skip)
  // Day 23 - Fri Oct 24, 2025 → Semi Finals
  {
    matchNo: 36,
    stage: 'Semi Final',
    date: 'Fri Oct 24, 2025 | 6:30 PM IST',
    home: 'Mumbai Meteors',
    away: 'Goa Guardians',
    score: '3-0',
    sets: '15:8 15:8 16:14',
  },
  {
    matchNo: 37,
    stage: 'Semi Final',
    date: 'Fri Oct 24, 2025 | 8:30 PM IST',
    home: 'Bengaluru Torpedoes',
    away: 'Ahmedabad Defenders',
    score: '3-1',
    sets: '10:15 15:11 15:13 15:13',
  },
  // Day 24 - Sat Oct 25, 2025 → Rest Day (skip)
  // Day 25 - Sun Oct 26, 2025 → Final
  {
    matchNo: 38,
    stage: 'Final',
    date: 'Sun Oct 26, 2025 | 6:30 PM IST',
    home: 'Mumbai Meteors',
    away: 'Bengaluru Torpedoes',
    score: '0-3',
    sets: '',
  },
];
